
import React from 'react';
import { FileUpIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  onSelectFile: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onSelectFile }) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-8 text-center">
        <FileUpIcon className="h-10 w-10 text-gray-400 mb-4" />
        <h3 className="text-lg font-medium mb-2">No File Selected</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Upload an Excel file (.xlsx or .xls) with a column named "name" containing your category names.
        </p>
        <div className="space-y-2">
          <Button onClick={onSelectFile}>
            Select File
          </Button>
          <p className="text-xs text-muted-foreground">
            Make sure your Excel file has a column header named exactly "name" (case-sensitive).
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
